import { defHttp, ampHttp, kedexOnlineHttp } from '@/utils/axios/index';
import type { Response } from '#/axios';
import type { LoginResponse, OnlineLoginResult } from '../types/login';
import { UerMenuData } from '../types/userMgr';

enum Api {
  LOGIN = '/api/edge/user/login',
  ADLOGIN = '/api/app/getToken',
  resetPassword = '/api/edge/user/changePassword',
  getMenuKey = '/api/edge/user/getMenuKey',
  backupAuto = '/api/backup/auto',
  onlineLogin = '/api/edge/user/onlineLoginSuccess',
  logout = '/api/edge/user/logout',
  checkMasterAccount = '/v1/auth/user/checkMasterAccount',
  kolLoginSendVerify = '/v1/cloud/sendVerifyCode',
  kolLoginBycaptcha = '/v1/cloud/login/captcha',
  serverTimeZoneApi = '/api/timezone/time', // 获取服务器时区
  i18nTranslationApi = '/api/common/i18n-translation',
  loginWay = '/amp-main-service/inner/v2/system-setting/login-way'
}
export const loginApi = (data: any) =>
  defHttp.post<Response<LoginResponse>>({ url: Api.LOGIN, data });

export const adLoginApi = (params: any) =>
  defHttp.get<Response<LoginResponse>>({ url: Api.ADLOGIN, params });

export const resetPasswordApi = (data: any) =>
  defHttp.post<Response<any>>({ url: Api.resetPassword, data });

export const getMenuKey = () => defHttp.get<UerMenuData>({ url: Api.getMenuKey });

export const backupAuto = () => defHttp.get<Response<string>>({ url: Api.backupAuto });

export const onlineLogin = (params: { onlineToken: string }) =>
  defHttp.get<Response<OnlineLoginResult>>({ url: Api.onlineLogin, params });

export const logoutApi = () => defHttp.get<Response<any>>({ url: Api.logout });

// 检查是否云端超级管理员
export const checkMasterAccount = () =>
  kedexOnlineHttp.get<Response<any>>({ url: Api.checkMasterAccount });

export const kolLoginSendVerify = (phone: string) =>
  kedexOnlineHttp.get({ url: `${Api.kolLoginSendVerify}?phone=${phone}` });

export const kolLoginBycaptcha = (data) =>
  kedexOnlineHttp.post({ url: Api.kolLoginBycaptcha, data });

// 获取服务器时区
export const getServerTimeZone = () => defHttp.get({ url: Api.serverTimeZoneApi });

// 获取i18n国际化翻译配置查询
export const getI18nTranslation = (params: Record<string, string>) =>
  defHttp.get({ url: Api.i18nTranslationApi, params });

// 获取登录方式
export const getLoginWay = () => ampHttp.get<Response<0 | 1>>({ url: Api.loginWay });
